import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Button } from 'primeng/button';
import { Popover } from 'primeng/popover';
import { Tooltip } from 'primeng/tooltip';

interface Language {
  code: string;
  name: string;
  flagClass: string;
}

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [CommonModule, Button, Popover, Tooltip],
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.css'],
})
export class LanguageSelectorComponent {
  private translate = inject(TranslateService);

  currentLang = this.translate.currentLang || 'it';

  languages: Language[] = [
    { code: 'it', name: 'Italiano', flagClass: 'fi fi-it' },
    { code: 'en', name: 'English', flagClass: 'fi fi-gb' },
  ];

  getCurrentFlagClass(): string {
    const lang = this.languages.find((l) => l.code === this.currentLang);
    return lang?.flagClass || 'fi fi-it';
  }

  switchLanguage(langCode: string): void {
    this.currentLang = langCode;
    this.translate.use(langCode);
    localStorage.setItem('app-language', langCode);
  }
}
